import React from 'react';
import MediaQuery from 'react-responsive';
import './Education.css';

import Button from '../../../components/UI/Button/Button';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textarea from '../../../components/UI/Textarea/Textarea';
import Textbox from '../../../components/UI/Textbox/Textbox';
import MonthPicker from '../../../components/UI/MonthPicker/MonthPicker';
import Radio from '../../../components/UI/Radio/Radio';
import Aux from '../../../hoc/Auxi/Auxi';
import moment from 'moment';


/**
* @desc Education in candidate profile section
* @param props
* @return DOM element
*/
const Education = (props) => {
  const inValid = (props.edtnErrorFieldIndex.includes(props.index));
  const blurValid =  props.fieldPosition == props.index;
  const blurId = props.blurId;

  const imProperStartDate = (moment(new Date(props.dateEnd))._isValid && props.dateStart > props.dateEnd);
  const imProperEndDate = (props.dateStart > props.dateEnd);
  const inVaildStartDate = (!moment(new Date(props.dateStart))._isValid);
  const inVaildEndDate = (!moment(new Date(props.dateEnd))._isValid);
  let errorAccreditation = "";let errorInstitution = "";let errorAward ="";let errorDescription = "";
  if((inValid && props.accreditation.trim() === "" ) || (blurValid && props.accreditation.trim() === "" && blurId === 'accreditation' )){
    errorAccreditation = "Please Provide Course Title to continue";
  }
  if((inValid && props.institution.trim() === "" ) || (blurValid && props.institution.trim() === "" && blurId === 'institution' )){
    errorInstitution = "Please enter the Awarding body";
  }
  if((inValid && props.award.trim() === "" ) || (blurValid && props.award.trim() === "" && blurId === 'award' )){
    errorAward = "Please enter certification to continue";
  }
  if((inValid && props.description.trim() === "" ) || (blurValid && props.description.trim() === "" && blurId === 'description' )){
    errorDescription = "Please enter a description to continue";
  }
  return (
    <div className="profile-edit__item">
      <FormGrid grid="auto auto">
        <h2 className="profile-edit__item_h2">Course {props.index+1}<Button size="small" className="profile-edit__remove-button" onClick={(event) => props.removeEducation(event, props.index)}>Remove</Button></h2>
        <div className="profile-edit__edu-switch">
          <Radio 
            value={0} 
            name={'edu'+ parseInt(props.index+1)} 
            label="Education" 
            checked={(props.isTraining == 0) ? true : false} 
            onChange={(event) => props.handleIsTraining(event, props.index)} />
          <Radio 
            value={1} 
            name={'edu'+ parseInt(props.index+1)} 
            label="Training"  
            checked={(props.isTraining == 1) ? true : false} 
            onChange={(event) => props.handleIsTraining(event, props.index)} />
        </div>
      </FormGrid>
      <FormGrid>
        <div>
          <Textbox 
            id="accreditation" 
            label="Course Title" 
            placeholder="" 
            value={props.accreditation} 
            onChange={(event) => props.handleEducationChange(event, props.index)} 
            inValid={((blurValid && props.accreditation.trim() === "" && blurId === 'accreditation' ) || (inValid && props.accreditation.trim() === ""))?"Invalid":""}
            onBlur={(event) => props.handleOnBlurEducation(event, props.index)}>
            {errorAccreditation}
          </Textbox>
        </div>
      </FormGrid>
      <FormGrid>
        <Textbox 
          id="institution" 
          label="Awarding Body" 
          placeholder="" 
          value={props.institution} 
          onChange={(event) => props.handleEducationChange(event, props.index)} 
          inValid={((blurValid && props.institution.trim() === "" && blurId === 'institution' ) || (inValid && props.institution.trim() === ""))?"Invalid":""}
          onBlur={(event) => props.handleOnBlurEducation(event, props.index)}>  
          {errorInstitution}        
        </Textbox>
      </FormGrid>

      <MediaQuery query="(min-device-width: 768px)">
        <FormGrid grid="auto auto 135px">
          <div>
            <MonthPicker 
              id="dateStart" 
              label="From" 
              value={props.dateStart.slice(0, 10)} 
              fieldName='dateStart'
              fieldIndex={props.index}
              handleDateChange={props.handleEducationDateChange}
              className={((inValid || (blurValid && blurId === "dateStart")) && (inVaildStartDate || imProperStartDate))?"Invalid":""}
              error={((inValid || (blurValid && blurId === "dateStart")) && inVaildStartDate) ?"From Date must be included": ((inValid || (blurValid && blurId === "dateStart")) && imProperStartDate) ? "From date must be before To date" : null}
              dateStart={null}
              dateEnd={props.dateEnd?props.dateEnd:null}
              presentJob={false}

            />
          </div>
          <div>
            <MonthPicker 
              id="dateEnd" 
              label="To" 
              value={props.dateEnd.slice(0, 10)} 
              fieldName='dateEnd'
              fieldIndex={props.index}
              handleDateChange={props.handleEducationDateChange}
              className={((inValid || (blurValid && blurId === "dateEnd")) && (inVaildEndDate || imProperEndDate)) ? "Invalid":""}
              error={((inValid || (blurValid && blurId === "dateEnd")) && inVaildEndDate) ? "To Date must be included": ((inValid || (blurValid && blurId === "dateEnd")) && imProperEndDate) ? "From date must be before To date" : null}
              dateStart={props.dateStart?props.dateStart:null}
              dateEnd={null}
              presentJob={false}

              />
          </div>
        </FormGrid>
        <FormGrid grid="auto 135px">
          <Textbox id="award" 
          label="Certification" 
          placeholder="" 
          value={props.award} 
          onChange={(event) => props.handleEducationChange(event, props.index)} 
          onBlur={(event) => props.handleOnBlurEducation(event, props.index)}
          inValid={((blurValid && props.award.trim() === "" && blurId === 'award' ) || (inValid && props.award.trim() === ""))?"Invalid":""}>          
          {errorAward}
          </Textbox>
        </FormGrid>
      </MediaQuery>
      
      <MediaQuery query="(max-device-width: 767px)">
        <FormGrid grid="auto auto">
          <div>
            <MonthPicker 
              id="dateStart" label="From" 
              value={props.dateStart.slice(0, 10)} 
              fieldName='dateStart'
              fieldIndex={props.index}
              handleDateChange={props.handleEducationDateChange}
              className={((inValid || (blurValid && blurId === "dateStart")) && (inVaildStartDate || imProperStartDate)) ?"Invalid":""}
              error={((inValid || (blurValid && blurId === "dateStart")) && inVaildStartDate) ?"From Date must be included": ((inValid || (blurValid && blurId === "dateStart")) && imProperStartDate) ? "From date must be before To date" : null}
              dateStart={null}
              dateEnd={props.dateEnd?props.dateEnd:null}
              presentJob={false}
            />
          </div>
          <div>
            <MonthPicker 
              id="dateEnd" label="To" 
              value={props.dateEnd.slice(0, 10)}
              fieldName='dateEnd'
              fieldIndex={props.index}
              handleDateChange={props.handleEducationDateChange}
              className={((inValid || (blurValid && blurId === "dateEnd")) && (inVaildEndDate || imProperEndDate)) ? "Invalid":""}
              error={((inValid || (blurValid && blurId === "dateEnd")) && inVaildEndDate) ? "To Date must be included": ((inValid || (blurValid && blurId === "dateEnd")) && imProperEndDate) ? "From date must be before To date" : null}
              dateStart={props.dateStart?props.dateStart:null}
              dateEnd={null}
              presentJob={false}
              />
          </div>
        </FormGrid>
        <FormGrid grid="auto">
          <Textbox 
            id="award" 
            label="Certification" 
            placeholder="" 
            value={props.award} 
            onChange={(event) => props.handleEducationChange(event, props.index)} 
            inValid={((blurValid && props.award.trim() === "" && blurId === 'award' ) || (inValid && props.award.trim() === ""))?"Invalid":""}
            onBlur={(event) => props.handleOnBlurEducation(event, props.index)}
            errorMsg = {errorAward}
            >            
          </Textbox>
        </FormGrid>
      </MediaQuery>      
      <FormGrid>
        <Textarea 
          id="description" 
          label="Description" 
          placeholder="" onChange={(event) => props.handleEducationChange(event, props.index)}
          inValid={((blurValid && props.description.trim() === "" && blurId === 'description' ) || (inValid && props.description.trim() ==="")) ?"Invalid":""}          
          onBlur={(event) => props.handleOnBlurEducation(event, props.index)}
          errorMsg = {errorDescription}
          value={props.description}
        >
        </Textarea>        
      </FormGrid>
    </div>
  )
}


/**
* @desc Educations in candidate profile section
* @param props
* @return DOM element
*/
const Educations = (props) => {
  const updateText = props.edtnActive =="updated" ? "Updated" : "Update";
  const disabled = props.edtnActive =="update" ? 'disabled' : "";
  return (
    <Aux>
      {props.candidate.education.map((edu, index) => (
        <Education 
          key={index}
          index={index}
          {...edu}
          handleEducationChange={props.handleEducationChange}
          handleEducationDateChange={props.handleEducationDateChange}
          handleIsTraining={props.handleIsTraining}
          removeEducation={props.removeEducation}
          edtnErrorFieldIndex={props.edtnErrorFieldIndex}
          handleOnBlurEducation={props.handleOnBlurEducation}
          blurId = {props.blurId}
          fieldPosition = {props.fieldPosition}/>
      ))}
      <div className="profile-edit__section__buttons">
        <Button 
        uistyle="secondary" 
        className="profile-edit__add-button" 
        onClick={props.addEducation}
        >+ Add Education</Button>
        <Button className={props.edtnActive} disabled={disabled} onClick={(event)=>props.handleUpdateProfile(event,"edtnActive")}>{updateText}</Button>
      </div>
    </Aux>
  );
}

export default Educations;



// WEBPACK FOOTER //
// ./src/components/Recruiter/Education/Education.js